
import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Nav, Navbar, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OverallStudentAttendance from "components/OverallStudentAttendance/OverallStudentAttendance";
import CustomerJourneyChart from "components/CustomerJourneyChart/CustomerJourneyChart";
import FunnelChart from "components/FunnelChart/FunnelChart";
import Alerts from "components/Alerts/Alerts";
import { getEmotionHomePageSummaryService } from "services/api-service";
import "./Dashboard.css";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import SearchIcon from '@mui/icons-material/Search';
import ModeCommentIcon from '@mui/icons-material/ModeComment';

import { useLocation } from "react-router-dom";


import routes from "routes.js";

import logo1 from "assets/img/LiveIcon.png"

import HistorysTa from "./History";
import FaceSearch from "./FaceSearch";

import Dropdown from 'react-bootstrap/Dropdown';

import DropdownButton from 'react-bootstrap/DropdownButton';

// import { setStudent_name, setCamera_name, resetFilters } from '../../VisitRedux/filterSlice';

import { setStudentName, setCameraName } from "../visitRedux/filterSlice";
// ✅ make sure the relative path is correct

// operation

import { useDispatch, useSelector } from "react-redux";
// import { setStudent_name, setCamera_name, resetFilters } from "../visitRedux/filterSlice";
import TargetFaceTable from "./TargetFaceTable";
import { resetFilters } from "../visitRedux/filterSlice";
import axios from "axios";

// import {
//   setFilters,
//   fetchFilteredData,} from "../visitRedux/filterSlice";
import FilterDropdowns from "./FilterDropdowns";
import {
  Getdevoteesummary,
  Get_download_devotee_pdf,
  get_devotee_filter_options
} from "services/api-service";


function SDashboardT({ }) {

  const [employeeNames, setEmployeeNames] = useState([]);
  console.log('namesearch', employeeNames.data)

  //     console.log(
  //   "📸 All camera names:",
  //   employeeNames.map((emp) => emp[0].camera_name)
  // );
  const [filteredData, setFilteredData] = useState([]);

  const [records, setRecords] = useState([])
  const [selectedName, setSelectedName] = useState('');
  const [selectedCamera, setSelectedCamera] = useState("");
  console.log('iiiiiiiiiiiiiiiiiiiii', selectedCamera)





  var admin = localStorage.getItem("username");
  console.log("hdhhhvd", admin);
  const theme = useTheme();
  const md_matches = useMediaQuery(theme.breakpoints.down('md'));
  const sm_matches = useMediaQuery(theme.breakpoints.down('sm'));
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];

  const [allChartData, setAllChartData] = useState([]);
  const [selectedClassroom, setSelectedClassroom] = useState("");
  const [sessionDetails, setSessionDetails] = useState(null);
  const [selectedChartData, setSelectedChartData] = useState("");
  const [emotionChart, setEmotionChart] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    localStorage.getItem("selectedDate") || formattedToday
  );
  const [showTargetFaceTables, setShowTargetFaceTables] = useState(true);
  const [showHistory, setShowHistory] = useState(false);
  const [showFaceSearch, setShowFaceSearch] = useState(false);

  const [activeButton, setActiveButton] = useState("dashboard"); // Track the active button

  const [rows, setRows] = useState([])
  console.log('ddddddddddddddddddddddddddddddddddddddddddddd', rows)




  const [homePageSummary, setHomePageSummary] = useState(() => {
    const storedData = localStorage.getItem("homePageSummary");
    return storedData ? JSON.parse(storedData) : [];
  });
  const handleDashboardClick = () => {
    setActiveButton("dashboard");
    setShowTargetFaceTables(true);
    setShowHistory(false);
    setShowFaceSearch(false);
  };

  const handleHistoryClick = () => {
    setActiveButton("history");
    setShowHistory(true);
    setShowTargetFaceTables(false);
    setShowFaceSearch(false);
  };

  const handleFaceSearchClick = () => {
    setActiveButton("facesearch");
    setShowFaceSearch(true);
    setShowTargetFaceTables(false);
    setShowHistory(false);
  };


  const fetchDataByDate = async () => {
    if (!selectedDate) {
      toast.error("Please select a valid date.");
      return;
    }

    console.log("📡 Fetching data for date:", selectedDate);

    try {
      const response = await getEmotionHomePageSummaryService({
        date: selectedDate,
      });
      setEmotionChart([]);
      setHomePageSummary(response.data);

      console.log("✅ Fetched home page summary data:", response.data);

      toast.success("Data loaded successfully!");
    } catch (error) {
      console.error("❌ Error fetching data by date:", error);
      toast.error("Failed to fetch data for the selected date.");
    }
  };


  // Handle date change
  const handleStartDateChange = (e) => {

    setSelectedDate(e.target.value);
    localStorage.setItem("selectedDate", e.target.value);
  };

  // Filter emotion chart data dynamically
  const filteredEmotionChart = useMemo(() => {
    if (!selectedChartData) return [];
    const id = selectedChartData.split(" ");
    return homePageSummary.filter((item) => item.session_id === id[1]);
  }, [selectedChartData, homePageSummary]);

  useEffect(() => {
    if (selectedDate) {
      console.log("🔄 Component mounted or selectedDate changed:", selectedDate);
      fetchDataByDate();
      fetchDataByDates()
    }
  }, [selectedDate]);
  const location = useLocation();
  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  };

  const getBrandText = () => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };



  useEffect(() => {
    fetchEmployees()
  }, []);

  const fetchEmployees = async () => {
    get_devotee_filter_options()
      .then((response) => {
        console.log('g', response.data)
        setEmployeeNames(response.data);
        setRows(response.data)

      })
      .catch(() => { });
  }



  const [selectedStudent, setSelectedStudent] = useState(
    localStorage.getItem("selectedName") || ""
  );
  useEffect(() => {
    localStorage.setItem("selectedDate", selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    localStorage.setItem("selectedName", selectedStudent);
  }, [selectedStudent]);

  useEffect(() => {
    localStorage.setItem("selectedCamera", selectedCamera);
  }, [selectedCamera]);

  const [uniqueStudents, setUniqueStudents] = useState([]);
  const [uniqueCameras, setUniqueCameras] = useState([]);
  useEffect(() => {
    const students = [...new Set(rows.map((item) => item.student_name))];
    const cameras = [...new Set(rows.map((item) => item.camera_name))];

    setUniqueStudents(students);
    setUniqueCameras(cameras);
  }, []);
  useEffect(() => {
    if (rows && rows.camera_names && rows.student_names) {
      setUniqueStudents(rows.student_names);
      setUniqueCameras(rows.camera_names);
    }
  }, [rows]);


  const handleSelect = (name) => {
    setSelectedName(name); // store in Redux

  };
  const handleSelectcamera = (name) => {
    setSelectedCamera(name); // store in Redux

  };

  useEffect(() => {
    localStorage.setItem("selectedCamera", selectedCamera);
  }, [selectedCamera]);


  useEffect(() => {
    localStorage.setItem("selectedName", selectedName);
  }, [selectedName]);

  useEffect(() => {
    let sorted = [...records];

    if (selectedName) {
      sorted.sort((a, b) => {
        if (a.student_name === selectedName && b.student_name !== selectedName) return -1;
        if (a.student_name !== selectedName && b.student_name === selectedName) return 1;
        return 0;
      });
    }

    if (selectedCamera) {
      sorted.sort((a, b) => {
        if (a.camera_name === selectedCamera && b.camera_name !== selectedCamera) return -1;
        if (a.camera_name !== selectedCamera && b.camera_name === selectedCamera) return 1;
        return 0;
      });
    }

    setFilteredData(sorted);
  }, [selectedName, selectedCamera, records]);

  const [rowst, setRowst] = useState([])
  const [filteredRows, setfilteredRows] = useState([])



  const fetchDataByDates = async () => {
    const payload = {
      date: selectedDate,
    };

    try {
      const response = await Getdevoteesummary(payload);
      console.log("kkk", response?.data?.data);
      setRowst(response?.data?.data);
      setfilteredRows(response?.data?.data)
    } catch (error) {
      console.error("Error fetching data by date:", error);
    }
  };

  const filteredRowst = filteredRows.filter((row) => {
    const studentMatch = selectedStudent ? row.student_name === selectedStudent : true;
    const cameraMatch = selectedCamera ? row.camera_name === selectedCamera : true;
    return studentMatch && cameraMatch;
  });

  return (
    <>
      {md_matches ? <div className="dashboard-headers" style={{ marginTop: '0.1%', borderTop: 'none', }}>

        <div className="dashboard-header-contents" style={{}}>
          <div
            style={{

            }}
          >
            <span style={{
              fontWeight: "bold",
              color: activeButton === "dashboard" ? "#000" : "#a6a6a6", // Change color based on active button
              fontSize: "11px",
            }} onClick={handleDashboardClick}>Dashboard | </span><span style={{
              fontWeight: "bold",
              color: activeButton === "history" ? "#000" : "#a6a6a6", // Change color based on active button
              fontSize: "11px",
            }} onClick={handleHistoryClick}>History | </span><span style={{
              fontWeight: "bold",
              color: activeButton === "facesearch" ? "#000" : "#a6a6a6", // Change color based on active button
              fontSize: "11px",
             marginRight:'15px'

            }} onClick={handleFaceSearchClick}>FaceSearch |</span>

          </div>
          <div style={{gap:'10px'}}>
            <FilterDropdowns
            selectedStudent={selectedStudent}
            selectedCamera={selectedCamera}
            uniqueStudents={uniqueStudents}
            uniqueCameras={uniqueCameras}
            onStudentChange={setSelectedStudent}
            onCameraChange={setSelectedCamera}
          />
          </div>


          <div className="dashboard-controlss">
            <span style={{ color: "rgba(0, 0, 0, 0.5)", marginLeft: md_matches ? '20px' : '' }}>Date:</span>
            <input
              type="date"
              className="date-input"
              value={selectedDate}
              onChange={handleStartDateChange}
              aria-label="Select date"
              style={{ width: md_matches ? '130px' : '150px', marginLeft: '-2%' }}
            />

            <div style={{ color: 'blue', borderRadius: '20px' }} onClick={fetchDataByDate} >
              <SearchIcon style={{ fontSize: '20px' }}></SearchIcon>
            </div>

          </div>




        </div>
      </div> : <Navbar >

        <div  style={{ marginLeft: '10px', gap: '10px' }}>

          <span style={{
            fontWeight: "bold",

            color: activeButton === "dashboard" ? "#000" : "#a6a6a6", // Change color based on active button
            fontSize: "18px",
          }} onClick={handleDashboardClick}>Dashboard | </span><span style={{
            fontWeight: "bold",

            color: activeButton === "history" ? "#000" : "#a6a6a6", // Change color based on active button
            fontSize: "18px",
          }} onClick={handleHistoryClick}>History | </span><span style={{
            fontWeight: "bold",

            color: activeButton === "facesearch" ? "#000" : "#a6a6a6", // Change color based on active button
            fontSize: "18px",
            marginRight:'15px'
          }} onClick={handleFaceSearchClick}>FaceSearch |</span>

        </div>
       <div style={{}}>
         <FilterDropdowns
          selectedStudent={selectedStudent}
          selectedCamera={selectedCamera}
          uniqueStudents={uniqueStudents}
          uniqueCameras={uniqueCameras}
          onStudentChange={setSelectedStudent}
          onCameraChange={setSelectedCamera}
        />
       </div>

        <div className="dashboard-controls">
          <span style={{ color: "rgba(0, 0, 0, 0.5)", }}>Date:</span>
          <input
            type="date"
            className="date-input"
            value={selectedDate}
            onChange={handleStartDateChange}
            aria-label="Select date"
          />
          <div style={{ color: 'blue', borderRadius: '20px' }} onClick={fetchDataByDate} >
            <SearchIcon style={{ fontSize: '40px' }}></SearchIcon>
          </div>
        </div>

      </Navbar>}
      <div>
        {showTargetFaceTables && (
          <>
            {console.log("Filtered Rows:", filteredRowst)}
            {filteredRowst && <TargetFaceTable filteredRowst={filteredRowst} />}
          </>
        )}

        {showHistory && <HistorysTa selectedDate={selectedDate} />}
        <div>
          {showFaceSearch && <FaceSearch selectedDate={selectedDate} />}
        </div>
      </div>

    </>
  );
}

export default SDashboardT;
